export const BRAND_NAME = 'Ultrawin';
export const BRAND_DOMAIN = 'ultrawin.co';
export const PROVIDER_ID = 'BetFair';
export const BACKEND_DOMAIN = 'uvwin2024.co';
